import type { RouteRecordRaw } from 'vue-router';

import DefaultBarView from '@views/Navigation/DefaultBarView.vue';
import DefaultBreadcrumbView from '@views/Navigation/DefaultBreadcrumbView.vue';
import DefaultRailView from '@views/Navigation/DefaultRailView.vue';

import OrderDetail from '@views/Order/OrderDetail.vue';
import ContactEdit from '@views/Contact/Detail/Modals/ContactEdit.vue';

const usedPrefixes: string[] = [];

export default (prefix: string): RouteRecordRaw[] => {
    if (usedPrefixes.includes(prefix)) {
        throw new Error(`Order route prefix '${prefix}' is already in use`);
    }

    usedPrefixes.push(prefix);

    return [
        {
            path: 'order/:orderId',
            name: `${prefix}OrderDetail`,
            props: {
                default: (route) => ({
                    orderId: route.params.orderId,
                }),
            },
            components: {
                default: OrderDetail,
                bar: DefaultBarView,
                rail: DefaultRailView,
                breadcrumbs: DefaultBreadcrumbView,
            },
            children: [
                {
                    path: 'contact-edit',
                    name: 'orderContactEdit',
                    props: {
                        default: (route) => ({
                            contactId: route.params.contactId,
                        }),
                    },
                    components: {
                        default: ContactEdit,
                    },
                },
            ],
        },
    ];
};
